import { styled } from '@mui/material/styles';
import Overline from '@components/Overline';

export const RAIL_WIDTH = 224;
export const RAIL_COLLAPSED_WIDTH = 56;

export const RailContainer = styled('div', {
    shouldForwardProp: prop => prop !== 'collapsed',
})(({ collapsed }) => ({
    width: collapsed ? RAIL_COLLAPSED_WIDTH : RAIL_WIDTH,
    flex: 'none',
    display: 'flex',
    flexDirection: 'column',
    height: 'var(--100vh)',
    backgroundColor: '#F7F9F9',
    borderRight: '1px solid #E4EAEB',
    padding: collapsed ? '0 4px 16px' : '0 10px 16px',
    overflowY: 'auto',
    overflowX: 'hidden',
    transition: 'width 0.2s ease-in-out',
}));

export const RailHead = styled('div', {
    shouldForwardProp: prop => prop !== 'collapsed',
})(({ collapsed }) => ({
    display: 'flex',
    flex: 'none',
    alignItems: 'center',
    justifyContent: collapsed ? 'center' : 'space-between',
    gap: 8,
    padding: collapsed ? '19px 0 4px' : '19px 0 4px 8px',
    '& .MuiIconButton-root': {
        color: 'var(--text-secondary)',
    },
}));

export const SectionTitle = styled(Overline)({
    flex: 'none',
    margin: '16px 8px 6px',
    whiteSpace: 'nowrap',
});

export const SectionDivider = styled('div')({
    flex: 'none',
    borderTop: '1px solid rgba(0, 0, 0, 0.08)',
    margin: '12px 8px 12px 0',
});

export const RailItemButton = styled('div', {
    shouldForwardProp: prop => prop !== 'active' && prop !== 'collapsed',
})(({ active, collapsed }) => ({
    display: 'flex',
    // The rail is a flex column; without this, overflowing items compress
    // instead of scrolling on short windows
    flex: 'none',
    alignItems: 'center',
    justifyContent: collapsed ? 'center' : 'flex-start',
    gap: 10,
    height: 36,
    padding: collapsed ? 0 : '0 8px',
    borderRadius: 8,
    cursor: 'pointer',
    backgroundColor: active ? 'var(--secondary-light)' : 'transparent',
    marginBottom: 2,
    '&:hover': {
        backgroundColor: active ? 'var(--secondary-light)' : 'var(--action-hover)',
    },
    '& > svg': {
        fontSize: 18,
        flex: 'none',
        color: active ? 'var(--primary-main)' : 'var(--text-secondary)',
    },
}));

export const TagDotSlot = styled('span')({
    display: 'inline-flex',
    width: 18,
    flex: 'none',
    alignItems: 'center',
    justifyContent: 'center',
});

export const RailItemLabel = styled('span', {
    shouldForwardProp: prop => prop !== 'active',
})(({ active }) => ({
    flex: 1,
    fontFamily: 'Rubik, sans-serif',
    fontSize: 14,
    lineHeight: '20px',
    fontWeight: active ? 500 : 400,
    color: active ? 'var(--primary-main)' : 'var(--text-primary)',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    minWidth: 0,
}));

export const RailItemCount = styled('span', {
    shouldForwardProp: prop => prop !== 'active',
})(({ active }) => ({
    fontFamily: 'Rubik, sans-serif',
    fontSize: 12,
    lineHeight: '16px',
    color: active ? 'var(--primary-main)' : 'var(--text-tertiary)',
    fontVariantNumeric: 'tabular-nums',
    flex: 'none',
}));
